import { duration } from 'src/replicant/utils/duration';
import { Match2Reward } from '../rewards/match2-rewards.ruleset';

/**
 * Limit of players shown in the leaderboard.
 */
export const leaderboardSize = 100;

/**
 * Leaderboard rewards.
 */
export const leaderboardReward: Array<{
  rangeEnd: number;
  reward: Match2Reward[];
}> = [
  {
    rangeEnd: 1,
    reward: [{ type: 'gems', amount: 5000 }],
  },
  {
    rangeEnd: 2,
    reward: [{ type: 'gems', amount: 2000 }],
  },
  {
    rangeEnd: 3,
    reward: [{ type: 'gems', amount: 1000 }],
  },
  {
    rangeEnd: 10,
    reward: [{ type: 'boosters', subType: 'dart', amount: 5 }],
  },
  {
    rangeEnd: 100,
    reward: [{ type: 'boosters', subType: 'dart', amount: 3 }],
  },
];

/**
 * League expiration time.
 */
export const leagueExpirationTime = duration({ days: 90 });

/**
 * League leaderboard.
 */
export type LeagueLeaderboard = {
  leaderboard: LeagueLeaderboardEntry[];
  playerRank: number;
};

export type LeagueLeaderboardEntry = {
  id: string;
  rank: number;
  phase?: number;
  score: number;
  name: string;
  photo: string;
  modifiedAt: number;
  me?: boolean;
};
